jQuery(function($) {
  if ($('#in-page-nav').length) {
    // ナビゲーションのリンクを指定
    var navLink = $('#in-page-nav li a');
    var contentsArr = new Array();

    // 各コンテンツのページ上部からの開始位置と終了位置を配列に格納しておく
    function setPosition() {
      for (var i = 0; i < navLink.length; i++) {
        // コンテンツのIDを取得
        var targetContents = navLink.eq(i).attr('href');
        // ページ内リンクでないナビゲーションが含まれている場合は除外する
        if (targetContents.charAt(0) == '#') {
          // ページ上部からコンテンツの開始位置までの距離を取得
          var targetContentsTop = $(targetContents).offset().top;
          // ページ上部からコンテンツの終了位置までの距離を取得
          var targetContentsBottom = targetContentsTop + $(targetContents).outerHeight(true) - 1;
          // 配列に格納
          contentsArr[i] = [targetContentsTop, targetContentsBottom]
        }
      }
    };

    // 現在地をチェックする
    function currentCheck() {
      const current = navLink.filter('.current')
      //console.log(current.length)
      if ((window.location.hash.length > 0) && (current.length > 0)) {
        const url = new URL(current[0].href)
        if (url.hash === window.location.hash) {
          return;
        }
      }
      // 現在のスクロール位置を取得
      var windowScrolltop = $(window).scrollTop()+10;
      if (windowScrolltop < contentsArr[0][0] || windowScrolltop > contentsArr[contentsArr.length-1][1]) {
        navLink.removeClass('current');
      } else {
        for (var i = 0; i < contentsArr.length; i++) {
          // 現在のスクロール位置が、配列に格納した開始位置と終了位置の間にあるものを調べる
          if (contentsArr[i][0] <= windowScrolltop && contentsArr[i][1] >= windowScrolltop) {
            // 開始位置と終了位置の間にある場合、ナビゲーションにclass="current"をつける
            navLink.removeClass('current');
            navLink.eq(i).addClass('current');
            i == contentsArr.length;
          }
        }
      }
    };

    if (window.location.hash.length > 0) {
      const aTag = navLink.filter('[href="' + window.location.hash + '"]');
      aTag.addClass('current')
    }
    // ページ読み込み時に、リンクの位置設定と現在地チェックを実行
    $(window).on('load', function() {
      setPosition();
      currentCheck();
    });

    // ページスクロール時に、現在地チェックを実行
    $(window).on('scroll', function() {
      currentCheck();
    });
  };
});
